const useNotify = {
 state: () => ({
  message: '',
  /**
   * @type { 'error' | 'success' }
   */
  type: 'error',
  show: false,
 }),
 mutations: {
  handleNotify(state, { message = '', type = 'error' }) {
   state.message = message
   state.type = type
   state.show = true
   setTimeout(() => {
    state.show = false
   }, 3000)
  }
 },
 getters: {
  notify: state => {
   return state
  }
 }
}
export default useNotify